import { Charts } from './Charts';
import DeathCauseChartsDataProvider from './contexts/DeathCauseChartsDataContext';

const DeathCauseWrapper = () => {
    return (
        <DeathCauseChartsDataProvider>
            <Charts />
        </DeathCauseChartsDataProvider>
    );
};

export default DeathCauseWrapper;
